import React, { Component } from 'react';
import classnames from 'classnames'; //suporte pra adicionar classes aos elementos
import CommonPage from '../../../common/CommonPage';
import { Container, Row, Col } from 'react-grid-system';
import Progress from '../../../common/Progress';
import moment from 'moment';
import { Card } from '@material-ui/core';
import Dialog from '@common/Dialog';
import RaisedButton from '../../../common/RaisedButton';
import { List, ListItem, ListItemSecondaryAction, ListItemText, Grid, Paper } from '@material-ui/core'; //List
import Constants from '../../../data/Constants';
import { MenuItem, IconButton, Menu, Fade } from '@material-ui/core'; // Menu config
import { mem, percent } from '../../../util/MonitorUtils';
import './MonitorHome.css'
import CommonDelete from '../../../common/CommonDelete'
import { Radial } from 'sensrit-charts';
import { Sparklines, SparklinesLine, SparklinesSpots } from 'react-sparklines';
import Monitor from './monitor/monitor.js';
import { Chip, Avatar } from '@material-ui/core';
import GroupModal from '../GroupModal';
import Server from '../Server';
import Link from '../Link';
import LinkNew from '../LinkNew';
import ServerConfig from '../ServerConfig';

const tenant = Constants.Tenant;

var img = 'data:image/png;base64,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';

// --------------------------------Função ícone----------------------------------
/*function Icon(props){
	return(
		<div className='iconContainer'>
			<div className='statusCustomIcon' style={{background:props.color}}>    
						<i className={`fas fa-${props.icon}`}></i>
					</div>
					{!!props.current && <span>{props.current}</span>}
				</div>
	)
}*/
// --------------------------------funções----------------------------------
function Graph_circle(props) {
	return (

		<div className='graphs-item'>
			<h4 className='title'>{props.title}</h4>
			<Radial
				low={{ color: '#33ABA0' }} mid={{ color: '#FFC107', value: 60 }}
				high={{ color: '#F44336', value: 80 }}
				className="host-graph-perc radial-graph-item-of-group"
				size={60}
				current={props.current}
				total={100}
				thick={8}
			>
				<h4 className='d-flex align-items-center'><i className={props.icon}></i> {props.current}%</h4>
			</Radial>
			<h4 className='sub-title'>{props.subTitle}</h4>
		</div>

	)
}

function Graph_badge(props) {
	return (

		<div className='graphs-item'>
			<Radial
				low={{ color: props.color }} mid={{ color: props.color }}
				high={{ color: props.color }}
				className="host-graph-perc radial-graph-item-of-group"
				size={40}
				current={props.current}
				total={props.current}
				thick={8}
			>
				<h4 className='d-flex align-items-center'>{props.current}</h4>
			</Radial>
		</div>

	)
}

function Graph_progress(props) {

	return (
		<div className='graphs-progress-item'>
			{!!props.title && <span className='title' style={{ fontWeight: 900 }}>{props.title}</span>}
			<Progress low={{ color: '#33ABA0' }} mid={{ color: '#FFC107', value: props.warning }}
				high={{ color: '#F44336', value: props.danger }} current={props.current} />
		</div>
	)
}


let host = '';
let tokenApi = '';
var getConnection = '';
// -----------------------------------------------------------(COMPONENTE - ListGroupItem)-------------------------------------------------------------------------
class ListGroupItem extends CommonPage {
	constructor(props) {
		super(props);
		this.state = {
			visible: false,
			ListGroupItemShow: false,
			anchorEl: null,
			open: null,
			available: false,
			mount: true,
			hold: '',
			aliveHold: '',
			values: {},
			diskIndex: 0,
			netIndex: 0,
			memory: [],
			memoryUsed: [],
			memoryUsedPercent: [],
			memoryUsedDash: 0,
			cpuUsedDash: 0,
			cors: [],
			uptime: [],
			cpuPerc: [],
			procStats: [],
			disk: [],
			netStats: [],
			netStatsTx: [],
			netStatsRx: [],
			removeloading: true,
			dateUnavailableServer: '',
			open: '',
			online: false

		}
		//	this.aliveSignal = this.aliveSignal.bind(this);
		//	this.fetchAll    = this.fetchAll.bind(this);
	}

	componentWillMount() {
		try {
			if (this.props.ioServers != undefined) {
				this.props.ioServers.on(`_${tenant}_${this.props.device.id_device}`, (data) => {
					let getDevice = this.props.monitor.find(m => m.id_device === this.props.device.id_device);
					clearTimeout(this.state.hold);
					if (data.offline == false) {
						this.setState({ online: true })
					} else {
						this.setState({ online: false })
					}

					if (data.item == "cpu-stats") {

						let cp = data.data
						let cpuUsedDash = cp.usedPercent;


						if (getDevice != undefined) {
							if (parseInt(getDevice.conf[data.item].triggers.danger.value) <=
								parseInt(cpuUsedDash)) {

								this.props.updateCountMaster('r', this.props.device.id_device + 'c');
							} else if (parseInt(getDevice.conf[data.item].triggers.warning.value) <=
								parseInt(cpuUsedDash)) {

								this.props.updateCountMaster('d', this.props.device.id_device + 'c');
							} else {

								this.props.updateCountMaster('o', this.props.device.id_device + 'c');
							}


						}






						this.setState({ cpuUsedDash: parseInt(cpuUsedDash) })


					} if (data.item == "mem-info") {
						let memoryTemp = data.data
						let memoryUsedTempS = String(memoryTemp.usedPercent).replace(',', '.')
						let memoryUsedTempI = memoryUsedTempS * 100
						let memoryUsedDash = (memoryTemp.actualUsed / memoryTemp.total) * 100;

						if (getDevice != undefined) {
							if (parseInt(getDevice.conf[data.item].triggers.danger.value) <=
								parseInt((memoryTemp.actualUsed / memoryTemp.total) * 100)) {

								this.props.updateCountMaster('r', this.props.device.id_device + 'm');
							} else if (parseInt(getDevice.conf[data.item].triggers.warning.value) <=
								parseInt((memoryTemp.actualUsed / memoryTemp.total) * 100)) {

								this.props.updateCountMaster('d', this.props.device.id_device + 'm');
							} else {

								this.props.updateCountMaster('o', this.props.device.id_device + 'm');
							}


						}
						this.setState({
							memory: mem(memoryTemp.total),
							memoryUsed: mem(memoryTemp.actualUsed),
							memoryUsedDash: memoryUsedDash
						})




					} if (data.item == "fs-list") {
						let diskTemp = data.data

						if (getDevice != undefined) {
							if (parseInt(getDevice.conf[data.item].triggers.danger.value) <=
								parseInt(percent(data.data[0].values.used, data.data[0].values.total))) {

								this.props.updateCountMaster('r', this.props.device.id_device + 'd');
							} else if (parseInt(getDevice.conf[data.item].triggers.warning.value) <=

								parseInt(percent(data.data[0].values.used, data.data[0].values.total))

							) {

								this.props.updateCountMaster('d', this.props.device.id_device + 'd');
							} else {

								this.props.updateCountMaster('o', this.props.device.id_device + 'd');
							}
						}

						this.setState({ disk: diskTemp, removeloading: true })




					}

					// {id_device: "3", item: "cpu-stats", data: {…}}data: {idle: 9700, total: 9900, usedPercent: 97.97979797979798}id_device: "3"item: "cpu-stats"__proto__: Object
					let hold = setTimeout(() => (1000));
					this.setState({ available: true, hold: hold });

				});
			}

		} catch (e) { }

	}


	handleModal(opts) {
		this.setState({ modalOpen: !this.state.modalOpen, modalOptions: opts });
	}
	toogleListGroup = () => {

		this.setState((state) => ({
			ListGroupItemShow: !state.ListGroupItemShow
		}));
	}
	handleClick = (event, v) => {

		this.setState({ anchorEl: event.currentTarget, open: v });
	}
	handleClose = () => {
		this.setState({ anchorEl: null, open: null });
	};
	render() {
		var ListGroupItemShow = classnames({
			active: this.state.ListGroupItemShow
		});
		let { ioLinks, device, handlePage, handleModal, ioServers, onRestartAgent, onDettachDevice } = this.props;
		let { open, anchorEl } = this.state;


		let getDevice = this.props.monitor.find(m => m.id_device === device.id_device);

		let cpuDanger = 0;
		let cpuWar = 0;

		let memDanger = 0;
		let memWar = 0;

		let fslistDanger = 0;
		let fslistWar = 0;

		try {
			cpuDanger = getDevice.conf["cpu-stats"].triggers.danger.value
			cpuWar = getDevice.conf["cpu-stats"].triggers.warning.value
			memDanger = getDevice.conf["mem-info"].triggers.danger.value
			memWar = getDevice.conf["mem-info"].triggers.warning.value

			fslistDanger = getDevice.conf["fs-list"].triggers.danger.value
			fslistWar = getDevice.conf["fs-list"].triggers.warning.value
		} catch (e) { }


		return (
			<li className="list-group-item">
				<div className='d-flex align-items-center justify-content-between'>
					<div className='d-flex align-items-center'>
						<a href="#" style={{ textDecoration: 'none' }} className=' mr-2' onClick={this.toogleListGroup}>
							<div className="control-order">
								<i className={"fas fa-" + (this.state.ListGroupItemShow ? 'minus' : 'plus')}></i>
							</div>
						</a>
						<span>{device.name}</span>
					</div>		 {device.type.toLowerCase() != 'server' && device.type.toLowerCase() != 'desktop' ?


						<LinkNew
							_device={getDevice}
							ioLinks={ioLinks}
							{...this.props}
							handleModal={this.props.handleModal}
						/>


						:

						<div className='bar-graph d-flex align-items-center justify-content-between'>

							{device.type.toLowerCase() === 'server' ||
								device.type.toLowerCase() === 'desktop'
								? <ServerConfig
									token
									online={this.state.online}
									_device={getDevice == undefined ? device : getDevice}
									ioServers={ioServers}
									onDettachDevice={onDettachDevice}
									onRestartAgent={onRestartAgent}
									handlePage={handlePage}
									action={this.props.action}
									APIEndpoints={this.props.APIEndpoints}
									{...this.props}
									handleModal={handleModal}
								/> : null
							}

							<Graph_progress
								danger={cpuDanger}
								warning={cpuWar}
								current={parseInt(this.state.cpuUsedDash)} title='CPU' />
							<Graph_progress
								danger={memDanger}
								warning={memWar}
								current={parseInt(this.state.memoryUsedDash)} title='Memória' />
							<Graph_progress
								danger={fslistDanger}
								warning={fslistWar}
								current={this.state.disk.length > 0 ?
									percent(this.state.disk[0].values.used,
										this.state.disk[0].values.total) : 0} title='Disco' />


						</div>}
				</div>

				<div className={`mt-3 expand-data ${ListGroupItemShow}`}>
					<hr />



					{(device.type.toLowerCase() === 'server' || device.type.toLowerCase() === 'desktop')
						? (

							<Server
								_device={getDevice == undefined ? device : getDevice}

								ioServers={ioServers}
								onRestartAgent={onRestartAgent}
								handlePage={handlePage}
								action={this.props.action}
								APIEndpoints={this.props.APIEndpoints}
								{...this.props}
								handleModal={handleModal}
							/>
						) : null}

					{(device.type.toLowerCase() != 'server' && device.type.toLowerCase() != 'desktop') ? (
						<Link
							_device={getDevice}
							{...this.props}
							ioLinks={ioLinks}
							handleModal={this.props.handleModal}
						/>) : null

					}

				</div>
			</li>
		)
	}
}




// -----------------------------------------------------------(COMPONENTE - ListGroup)----------------------------------------------------------------
class ListGroup extends Component {
	constructor(props) {
		super(props);
		this.state = {
			visible: false,
			ListGroupItemShow: false,
			countRedSub: [],
			countYellowSub: [],
			countOkSub: [],
			del: false,
			up: false,
			group: ''
		}


		this.onClose = this.onClose.bind(this);
		this.onDelete = this.onDelete.bind(this);
		this.onUpdate = this.onUpdate.bind(this);
		this.upGroup = this.upGroup.bind(this);


		this.updateCountSub = this.updateCountSub.bind(this);
	}

	onClose() {
		this.setState({
			del: false,
			up: false,
			group: ''
		});
	}

	updateCountSub(item, id_device) {

		if (item == 'r') {
			let value = this.state.countRedSub;

			if (value.indexOf(id_device) === -1) value.push(id_device);
			this.setState({ countRedSub: value })

		}
		if (item == 'e') {
			let value = this.state.countYellowSub;

			if (value.indexOf(id_device) === -1) value.push(id_device);
			this.setState({ countYellowSub: value })

		}
		if (item == 'o') {
			let value = this.state.countOkSub;

			if (value.indexOf(id_device) === -1) value.push(id_device);
			this.setState({ countOkSub: value })
		}
	}




	toogleListGroup = () => {

		this.setState((state) => ({
			ListGroupItemShow: !state.ListGroupItemShow
		}));
	}

	onClose() {
		this.setState({
			del: false,
			up: false,
			group: ''
		});
	}

	onDelete() {
		let { group } = this.state;
		this.props.upGroup(group, 'del');
		this.onClose();
	}

	onUpdate(values) {
		let { group } = this.state;
		this.props.upGroup(group, 'up', values);
		this.onClose();
	}

	upGroup(group, action) {
		let obj = { group: group };
		if (action === 'del') obj.del = true;
		if (action === 'up') obj.up = true;
		this.setState(obj);
	}
	render() {
		var ListGroupItemShow = classnames({
			show: this.state.ListGroupItemShow
		})
		let { gd, ioLinks, onDettachDevice, monitor, company, language, comp, companies, handlePage, handleModal, ioServers, onRestartAgent, updateCountMaster, upGroup } = this.props;
		let { del, group, up } = this.state;
		let divider = {
			width: '49%',

		}
		return (
			gd.devices.map(c => (
				<li style={this.props.divider ? divider : {}}>

					<div className={`list-container active `}>
						<ul className="list-group w-100">
							<ListGroupItem ioLinks={ioLinks} onDettachDevice={onDettachDevice} updateCountSub={this.updateCountSub}
								onRestartAgent={onRestartAgent} ioServers={ioServers} handleModal={handleModal} handlePage={handlePage}     {...this.props} device={c} />


						</ul>

						{
							del ? <CommonDelete
								language={language}
								closeModal={this.onClose}
								onDelete={this.onDelete}
							/> : up ? <GroupModal
								closeModal={this.onClose}
								companies={companies}
								comp={comp}
								company={company}
								group={group}
								devices={gd}
								open={up}
								language={language}
								onFormSubmit={this.onUpdate}
							/> : null
						}

					</div>
				</li>
			))
		)
	}
}


// ----------------------------------------------------------------(COMPONENTE - MyList)--------------------------------------------------------------------
class MyList extends Component {
	constructor(props) {
		super(props);
		this.state = {
			visible: false,
			list_active: false,


			countRed: [],
			countYellow: [],
			countOk: []
		}
		this.updateCountMaster = this.updateCountMaster.bind(this);
	}

	updateCountMaster(item, id_device) {

		if (item == 'r') {
			let value = this.state.countRed;

			if (value.indexOf(id_device) === -1) value.push(id_device);
			this.setState({ countRed: value })



		}
		if (item == 'e') {
			let value = this.state.countYellow;

			if (value.indexOf(id_device) === -1) value.push(id_device);
			this.setState({ countYellow: value })

		}
		if (item == 'o') {
			let value = this.state.countOk;

			if (value.indexOf(id_device) === -1) value.push(id_device);
			this.setState({ countOk: value })
		}


	}
	toogleListGroup = () => {

		this.setState((state) => ({
			list_active: !state.list_active
		}));
	}
	render() {
		var listClass = classnames({
			active: this.state.list_active
		})
		let defaultStyle = { border: 'solid 1px #ddd' };
		let dangerStyle = { boxShadow: '0px 1px 21px 0px rgba(255,0,0,1)' };
		let warningStyle = { boxShadow: '0px 1px 21px 0px rgba(255,255,0,1)' };

		let { monitorGroup, ioLinks, onDettachDevice, danger, warning, monitor, handlePage, handleModal, ioServers, onRestartAgent,
			upGroup,
			companies,
			language
		} = this.props;

		let { countRed,
			countYellow,
			countOk } = this.state;

		if (!monitorGroup) return <div />;




		return (

			<React.Fragment>



				<ListItem className={`lists listItem grid-container-100 active`} dense button>
					<div className='grid-item' colspan="3">
						<div className='list-card'>
							{this.props.list ? (
								<ul className={classnames('list-group', { 'list-group-flex': !!this.props.divider })}>
									{monitorGroup.groups.map((gd, i) => (
										<ListGroup ioLinks={ioLinks} divider={!!this.props.divider} onDettachDevice={onDettachDevice} comp={monitorGroup.company} updateCountMaster={this.updateCountMaster} company={[]} companies={companies} upGroup={upGroup} onRestartAgent={onRestartAgent} ioServers={ioServers} handleModal={handleModal} handlePage={handlePage}  {...this.props} gd={gd} />

									))}
								</ul>
							) : (
								<Monitor cp={true} />
							)}
						</div>
					</div>
				</ListItem>
			</React.Fragment>
		);
	}
}


// ---------------------------------------------------------(COMPONENTE - MonitorHome)---------------------------------------------------------------------------
class MonitorHomeAll extends Component {
	constructor(props) {
		super(props);
		this.state = {
			list: true,
			filterServer: false,
			filterLink: false,
			modalOpen: false,
			modalOptions: {},
			update: 0,
			removeloading: true

		}
		this.onFilter = this.onFilter.bind(this);
		this.handleModal = this.handleModal.bind(this);
		this.updateState = this.updateState.bind(this);

	}



	updateState() {
		//this.props.state.page = 'monitor';
		// setTimeout(this.updateState, 5000, this);
	}

	onFilter(filter) {
		this.setState(filter);
	}

	handleModal(opts) {
		this.setState({ modalOpen: !this.state.modalOpen, modalOptions: opts });
	}


	changeView = () => {
		this.setState((state) => ({
			list: !state.list
		}))
	}

	render() {
		let {
			danger,
			language,
			companies,
			handlePage,
			DashboardMonitor,
			monitor,
			monitorGroups,
			warning,
			onDettachDevice,
			onRestartAgent,
			ioServers,
			upGroup,
			ioLinks
		} = this.props;
		let defaultStyle = { border: 'solid 1px #ddd' };
		let { filterServer, filterLink, modalOpen, modalOptions } = this.state;
		return (

			<div id='MonitorHome'>

				<Grid container spacing={3}>
					<Grid item xs={12} className='title-page'>
						<Paper className='paper d-flex justify-content-between align-items-center'>
							<p>{language.MONITOR}</p>
							<a href="#" onClick={() => handlePage('dash')}>
								<i className={'fas fa-columns'}></i>
							</a>
						</Paper>
					</Grid>


					{monitorGroups.map((monitorGroup, i) => (
						<Grid item xs={monitorGroups.length == 1 ? 12 : 6}>
							<Paper className='paper'>
								<List className='list listMin'>

									<MyList     {...this.props}
										toDetails={() =>
											handlePage('groupDetail', monitorGroup)}

										hintTextSearch={language.SEARCH_GROUP}
										ioLinks={ioLinks}
										divider={monitorGroups.length == 1}
										styleStatus={defaultStyle}
										language={language}
										onDettachDevice={onDettachDevice}
										upGroup={upGroup}
										ioServers={ioServers}
										monitorGroup={monitorGroup}
										addGroupDevice={this.handleModal}
										dataTip={language.ADD_MONITORING_GROUP}
										editDtip={language.EDIT}
										companies={companies}
										handlePage={handlePage}
										onRestartAgent={onRestartAgent}
										handleModal={this.handleModal}
										trashDtip={language.REMOVE}
										danger={danger}
										warning={warning}
										monitorGroup={monitorGroup} list={this.state.list} key={i} />
								</List>
							</Paper>
						</Grid>)

					)}


				</Grid>
				{modalOptions && Object.keys(modalOptions).length ? (
					<Dialog

						open={modalOpen}
						bodyStyle={{ padding: 0, overflowY: 'none' }}
						onClose={() => this.handleModal}
						title={modalOptions.confirm ? language.CONFIRMATION : 'Sensr Conf'}
					>

						<h2 style={{ color: '#616161', fontWeight: 100 }}>{modalOptions.msg}</h2>
						<Row className="row" style={{ padding: '20px 0px' }}>
							<Col
								md={modalOptions.confirm ? 5 : 2}
								offset={{ md: modalOptions.confirm ? 7 : 10 }}
							>
								{modalOptions.confirm ? (
									<RaisedButton
										primary={true}
										label={language.IM_SURE}
										onClick={modalOptions.confirm}
									/>
								) : null}
								<RaisedButton
									primary={false}
									label={language.CANCEL}
									onClick={this.handleModal}
									style={{ marginLeft: 10 }}
								/>
							</Col>
						</Row>

					</Dialog>
				) : null}
			</div>

		)
	}
}
export default MonitorHomeAll;